const TOKEN_KEY = "senlem_admin_token";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { skipAuthRedirect, ...options } = {}) {
    const token = getToken();
    const headers = { ...(options.headers || {}) };
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    if (options.body && !(options.body instanceof FormData)) {
        headers["Content-Type"] = "application/json";
    }

    const res = await fetch(path, { ...options, headers });

    // Un 401 sur un appel authentifié signifie que la session n'est plus valide
    // (token expiré, révoqué par un changement de mot de passe, etc.) : on renvoie
    // systématiquement vers l'écran de connexion plutôt que de laisser l'admin
    // face à une page cassée. Exclu pour login/me/changePassword, où un 401 est une
    // réponse métier normale (mauvais identifiants) à afficher sur place, pas une
    // session expirée.
    if (res.status === 401 && !skipAuthRedirect) {
        clearToken();
        if (!window.location.pathname.startsWith("/admin/login")) {
            window.location.href = "/admin/login";
        }
    }

    if (!res.ok) {
        let message = `Erreur ${res.status}`;
        try {
            const data = await res.json();
            if (data.error) message = data.error;
        } catch {
            // ignore
        }
        const error = new Error(message);
        error.status = res.status;
        throw error;
    }

    if (res.status === 204) return null;
    return res.json();
}

export const api = {
    getContent: () => request("/api/content", { skipAuthRedirect: true }),

    login: (username, password) =>
        request("/api/auth/login", {
            method: "POST",
            body: JSON.stringify({ username, password }),
            skipAuthRedirect: true
        }),
    me: () => request("/api/auth/me", { skipAuthRedirect: true }),
    changePassword: (currentPassword, newPassword) =>
        request("/api/auth/change-password", {
            method: "POST",
            body: JSON.stringify({ currentPassword, newPassword }),
            skipAuthRedirect: true
        }),

    list: (resource) => request(`/api/admin/${resource}`),
    create: (resource, data) =>
        request(`/api/admin/${resource}`, { method: "POST", body: JSON.stringify(data) }),
    update: (resource, id, data) =>
        request(`/api/admin/${resource}/${id}`, { method: "PUT", body: JSON.stringify(data) }),
    remove: (resource, id) =>
        request(`/api/admin/${resource}/${id}`, { method: "DELETE" }),
    move: (resource, id, direction) =>
        request(`/api/admin/${resource}/${id}/move`, {
            method: "PATCH",
            body: JSON.stringify({ direction })
        }),

    getSettings: () => request("/api/admin/settings"),
    updateSettings: (data) =>
        request("/api/admin/settings", { method: "PUT", body: JSON.stringify(data) }),

    upload: (section, file) => {
        const formData = new FormData();
        formData.append("file", file);
        return request(`/api/admin/upload/${section}`, { method: "POST", body: formData });
    }
};
